module.exports = __webpack_public_path__ + "static/media/DOCUMENTAÇÃO_DAS_ANÁLISES_-_REPORTS.3424e1f8.pdf";